import React ,{useContext , Fragment, useEffect} from "react";
import {FaHeart} from "react-icons/fa";
import {RoomContext} from "../../../Context";
import {Link , withRouter} from "react-router-dom";
import FavRoom from "./FavRoom/FavRoom";
import {ImHome} from "react-icons/im";
import {MdClearAll} from "react-icons/md";
const Favorites =(props)=>{
    const context = useContext(RoomContext);
    let {favRooms, deleteRoom, clearCart} = context; //destructuring favRooms form context
    // const allRooms = [...items];
    // let allIds = favRooms.map(item => item);
    //  let roomsToRender= [];
    //  const getRoomById = (id)=>{
    //      const selectedRoom = allRooms.find( item => item.id === id);
    //      return selectedRoom;
    //  }
    // for(let i = 0; i < favRooms.length; i++){
    //         roomsToRender.push(getRoomById(allIds[i]));
    // }

    useEffect(()=>{
        document.title = "Beach Resort | Favorites"
        window.scrollTo(0,0);
     },[]);

        return(
            <Fragment>
                <div className="comp-container container">
                    <p style={{margin:"20px 5px 0 5px"}}><Link to="/"><ImHome className="home-icon"/></Link> > <span className="selectedRoute">Favorites</span></p>
                    <hr/>
               
                    <h3><FaHeart/> Favorite Rooms</h3>
                    {
                        favRooms.length <1
                        ?
                        <h3 className="text-center mt-4 text-dark">No rooms to show currently. Add rooms to favorites and get back again.</h3>
                        :
                        <div>
                            <div className="fav-room-main">
                                { favRooms.map((item, index) =>{
                                    return(<FavRoom room ={item} key={index} deleteRoom={(type, id, index)=> deleteRoom(type,id,index)} index={index} /> )
                                    }) 
                                }
                                
                            </div>
                            
                            <div>
                                <button className="clear-cart-btn" onClick={()=> {clearCart("favorites"); props.history.push("/");}}><MdClearAll/> Clear Favorites</button>
                            </div>
                        </div>
                    }
                    
                </div>
            </Fragment>
        )
    
}
export default withRouter(Favorites);